var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleIconStateStripeDefaulted2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.713867,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FF5500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.71387L5 3.71387L7.5 7.71387H2.5Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.11377V6.54234M5 6.97091V7.11377V6.82806",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleIconStateStripeDefaulted2);
export default __webpack_public_path__ + "static/media/littleIconStateStripeDefaulted2.2def985fdeaabbe8a8f5c2ac79780ccb.svg";
export { ForwardRef as ReactComponent };